import React from 'react';

const FormCard = ({ children, className = "", as: Component = "div", ...props }) => {
  // Common styles for all cards/inputs in your plugin
  const baseClasses = "w-full !bg-white border !border-[#E4E4E780] !rounded-xl !shadow-[0px_4px_6px_-4px_#00000014,0px_10px_15px_-3px_#00000014] transition-all p-6";
  
  return (
    <Component 
      className={`${baseClasses} ${className}`} 
      {...props}
    >
      {children}
    </Component>
  );
};

export default FormCard;